<!-- <div class="menu-item">
  <mat-icon
    class="menu-icon"
    svgIcon="chat"
  ></mat-icon>
</div> -->
work
